// contexts/User/index.jsx

import React, { useCallback, useEffect } from 'react';
import { reducer, initialState } from './reducer';
import {
  AUTH_SESSION_EXPIRED_EVENT_V104,
  markAuthenticatedV104,
} from '../../helpers/authSessionV104';

export const UserContext = React.createContext({
  state: initialState,
  dispatch: () => null,
});

export const UserProvider = ({ children }) => {
  const [state, update] = React.useReducer(reducer, initialState);
  const dispatch = useCallback((action) => {
    if (action.type === 'login') markAuthenticatedV104();
    update(action);
  }, []);

  useEffect(() => {
    const logout = () => update({ type: 'logout' });
    window.addEventListener(AUTH_SESSION_EXPIRED_EVENT_V104, logout);
    return () =>
      window.removeEventListener(AUTH_SESSION_EXPIRED_EVENT_V104, logout);
  }, []);

  return (
    <UserContext.Provider value={[state, dispatch]}>
      {children}
    </UserContext.Provider>
  );
};
